<template>
  <div class="info-box">
    <div class="flex-1 flex flex-col gap-y-3 pr-2 overflow-hidden">
      <div
        class="grid gap-x-3 overflow-hidden"
        style="grid-template-columns: 25% 1fr"
      >
        <div class="overflow-hidden pr-3">
          <div
            class="flex flex-col gap-y-2 overflow-y-auto"
            style="max-height: 90%"
          >
            <ul class="flex gap-x-3 items-center">
              <strong>{{ state.model?.number }}</strong>
              <text class="text-gray-400 text-xs">采购付款</text>
              <text v-if="state.model?.status == 0" class="text-xs">
                {{ state.model?.flowApproveStep?.step_name }}
              </text>
              <c_status
                v-else
                arrName="Office_Expense_Apply_Status"
                :value="state.model?.status"
                :key="state.model?.status"
                showBg
              />
            </ul>
            <c_cell title="付款金额">
              <c_money
                :key="state.model.amount"
                :value="state.model.amount"
                :size="20"
                :prefix="false"
                bold
              />
            </c_cell>
            <c_cell
              title="付款方式"
              :value="state.model?.d_payment_type_name"
            />
            <c_cell
              title="所属会议"
              :value="state.meeting?.name"
              class="items-baseline"
            >
              <div
                class="flex gap-x-3 items-center flex-wrap"
                v-if="state.meeting?.id"
              >
                <text>{{ state.meeting?.name }}</text>
                <text class="text-gray-400 text-xs">{{
                  state.meeting?.number
                }}</text>
                <c_status
                  arrName="Meeting_Status"
                  :value="state.meeting?.status"
                  :key="state.meeting?.status"
                  showBg
                />
              </div>
              <text v-else>-</text>
            </c_cell>
            <c_cell title="收款信息">
              <template #default>
                <div
                  class="flex gap-x-2"
                  v-if="state.model?.is_supplier_purchase"
                >
                  <text>{{
                    state.model?.supplierBankAccount?.opening_bank
                  }}</text>
                  <text class="text-gray-400">{{
                    state.model?.supplierBankAccount?.name
                  }}</text>
                  <text class="text-gray-400">{{
                    state.model?.supplierBankAccount?.account
                  }}</text>
                </div>
                <div class="flex gap-x-2" v-else>
                  <text>{{ state.model?.opening_bank }}</text>
                  <text class="text-gray-400">{{
                    state.model?.bank_account_name
                  }}</text>
                  <text class="text-gray-400">{{
                    state.model?.bank_account
                  }}</text>
                </div>
              </template>
            </c_cell>
            <c_cell title="申请说明" :value="state.model?.intro" />
            <c_cell title="附件">
              <template #default>
                <div
                  class="flex flex-wrap gap-x-5 gap-y-2"
                  v-if="state.model?.attachment?.length > 0"
                >
                  <text
                    v-for="file in state.model?.attachment"
                    :key="item"
                    class="hover:underline cursor-pointer text-green-700"
                    @click="$openFile(file.file_url)"
                  >
                    {{ file.filename }}
                  </text>
                </div>
                <text v-else>-</text>
              </template>
            </c_cell>
            <ul class="text-gray-400 text-xs">
              审核进度：
            </ul>
            <el-timeline class="!text-xs" style="padding-left: 5px">
              <el-timeline-item
                :hollow="item.status == 0"
                :type="
                  item.status === 0
                    ? 'info'
                    : item.status === 1
                    ? 'primary'
                    : 'danger'
                "
                hide-timestamp
                v-for="item in state.flowApproveStepList"
                :key="item"
              >
                <div class="flex flex-col gap-y-1">
                  <div class="flex gap-x-3 flex-wrap gap-y-1">
                    <strong>{{ item.step_name }}</strong>
                    <c_status
                      arrName="Common_Check_Status"
                      :value="item?.status"
                      :key="item?.status"
                    />
                  </div>
                  <c_cell title="操作人" :size="12" class="mt-1">
                    <ul>
                      <text>{{ item?.approve_admin_name }}</text>
                      <text class="text-gray-400 ml-1">{{
                        item?.approve_department_name
                      }}</text>
                    </ul>
                  </c_cell>
                  <ul class="text-xs" v-if="item?.approve_time">
                    <text class="text-gray-400">时间：</text>
                    <text> {{ item?.approve_time }}</text>
                  </ul>
                  <ul v-if="item?.log?.msg" class="text-xs">
                    <text class="text-gray-400">备注：</text>
                    <text>{{ item?.log?.msg }}</text>
                  </ul>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <template v-if="state.model.status === 0">
            <div
              class="border-t border-green-800 border-dashed mt-2 text-center flex justify-center"
            >
              <li
                class="text-green-800 font-bold bg-white px-5"
                style="margin-top: -10px; width: fit-content"
              >
                审批
              </li>
            </div>
            <el-input
              v-model="state.remark"
              type="textarea"
              :autosize="{ minRows: 3 }"
              placeholder="说明"
              class="round"
            />
            <div class="flex items-center justify-center mt-2">
              <el-button type="danger" size="large" @click="onSubmit(2)"
                >不通过</el-button
              >
              <el-button type="primary" size="large" @click="onSubmit(1)"
                >通过</el-button
              >
            </div>
          </template>
        </div>
        <div class="flex flex-col mb-12 overflow-hidden">
          <strong>采购明细</strong>
          <div class="flex-1 overflow-y-auto mt-2 pr-3">
            <el-card
              v-for="(row, index) in state.list_data"
              :key="row"
              class="mb-3"
            >
              <template #header>
                <div class="flex gap-x-5">
                  <strong>{{ index + 1 + "." + row.number }}</strong>
                  <c_cell title="结算价">
                    <c_money
                      :value="row.amount"
                      :prefix="false"
                      :size="14"
                      color="#1e90ff"
                    />
                  </c_cell>
                  <c_cell title="已付">
                    <c_money
                      :value="row.paid_amount"
                      :prefix="false"
                      :size="14"
                      color="#080"
                    />
                  </c_cell>
                  <c_cell title="应付">
                    <c_money
                      :value="row.unpaid_amount"
                      :prefix="false"
                      :size="14"
                      color="#ffa500"
                    />
                  </c_cell>
                  <c_cell title="本次付款" class="flex-1">
                    <c_money
                      :value="row.this_amount"
                      :prefix="false"
                      :size="18"
                      bold
                    />
                  </c_cell>
                  <div class="flex items-center text-gray-400 text-xs gap-x-2">
                    <text class="text-sm text-gray-600">
                      {{ row?.add_admin_name }}
                    </text>
                    <text>{{ row?.add_department_name }}</text>
                    <text class="ml-1">{{ row?.create_time }} 创建</text>
                  </div>
                </div>
              </template>
              <table class="w-full" cellpadding="10">
                <thead>
                  <tr class="text-left bg-gray-100">
                    <th style="width: 12%">所属分会</th>
                    <th style="width: 6%">类型</th>
                    <th style="width: 15%">名称</th>
                    <th style="width: 15%">规格</th>
                    <th style="width: 6%" class="text-center">单位</th>
                    <th style="width: 10%" class="text-center">单价</th>
                    <th style="width: 6%" class="text-center">数量</th>
                    <th style="width: 10%" class="text-center">合计</th>
                    <th>备注</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in row.meetingPurchaseItemData?.list"
                    :key="item"
                  >
                    <td>{{ item.meetingPlace?.name }}</td>
                    <td>{{ item.d_cost_type_pname }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.specification || "-" }}</td>
                    <td class="text-center">
                      {{ item.d_measure_unit_name || "-" }}
                    </td>
                    <td class="text-center">{{ item.bill_price }}</td>
                    <td class="text-center">{{ item.bill_count }}</td>
                    <td class="text-center">{{ item.bill_amount }}</td>
                    <td>{{ item.bill_remark || "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </el-card>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-box px-2.5 absolute bottom-0 right-0">
      <el-button plain :icon="Printer" @click="state.showPrint = true">
        打印采购付款单
      </el-button>
    </div>
  </div>
  <el-dialog
    v-model="state.showPrint"
    title="采购付款打印"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showPrint = false;
      }
    "
    style="width: 70%"
    append-to="#home_box"
    modal
  >
    <c_print :id="props.id" @close="state.showPrint = false" />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meetingpurchasepaymentapply_search,
  meetingpurchasepaymentapply_approve,
} from "@/http/fukuanshenpi";
import { ElMessage, ElMessageBox } from "element-plus";
import { post_response } from "@/utils/funcs";

import c_print from "./CaiGouShenPiPrint.vue";

export default {
  props: {
    id: Number,
  },
  components: {
    c_print,
  },
  setup(props, { emit }) {
    const state = reactive({
      model: {},
      list_data: [],
    });
    onMounted(() => {
      if (props.id) {
        meetingpurchasepaymentapply_search(props.id).then((res) => {
          if (res.status == 200) {
            const { info, meeting, meetingPurchaseList, flowApproveStepList } =
              res.data?.data || {};
            state.model = info;
            state.meeting = meeting;
            state.list_data = meetingPurchaseList;
            state.flowApproveStepList = flowApproveStepList;
          }
        });
      }
    });
    const onSubmit = (pass) => {
      if (!state.remark) {
        ElMessage.warning("请输入审批说明！");
        return false;
      }

      ElMessageBox.confirm(
        `您确定<strong style="color: ${pass == 1 ? "#080" : "#f00"};">${
          pass == 1 ? "同意" : "拒绝"
        }</strong>该付款申请吗？`,
        "付款审批",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meetingpurchasepaymentapply_approve({
          id: [props.id],
          status: pass,
          msg: state.remark,
        }).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              emit("close", true);
            }, 500);
          });
        });
      });
    };
    return { state, props, onSubmit };
  },
};
</script>
<style type="scss"></style>
